import { render, staticRenderFns } from "./InputNumberValue.vue?vue&type=template&id=3a15f1d0&"
import script from "./InputNumberValue.vue?vue&type=script&lang=js&"
export * from "./InputNumberValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports